var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "cm-chiclet",
    class: {
      checked: _vm.checked
    }
  }, [_c('input', _vm._b({
    staticClass: "cm-chiclet__input"
  }, 'input', {
    type: _vm.type,
    value: _vm.value,
    name: _vm.group,
    checked: _vm.checked
  }, false)), _vm._v(" "), _c('div', {
    staticClass: "cm-chiclet__label"
  }, [_vm._v("\n    " + _vm._s(_vm.label) + "\n  ")])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ad9bf9e","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/components/cm-chiclet.vue
// module id = null
// module chunks = 